import { defineComponent as _defineComponent } from 'vue'
import {computed, reactive, ref, onMounted} from "vue";
import {WebFormModel} from "capitalist-shared/src/core/model";
import SetupToggler from "@/views/pages/security/setup/SetupToggler.vue";
import httpAxiosApi from "capitalist-shared/src/core/axios.errors.handle";
import {RemoteRequestState} from "capitalist-shared/src/core/remote";


export default /*#__PURE__*/_defineComponent({
  __name: 'SecuritySetupThirdpartyAnalytics',
  setup(__props) {

class AnalyticsModel extends WebFormModel {
  loadingStatus = new RemoteRequestState();
  updatingStatus = new RemoteRequestState();

  activationSwitch(enable = true) {
    this.updatingStatus.loadStart();
    return httpAxiosApi.post('/webapi/webapi/securitysettings/updateAnalyticsSettings', {
      call: 'updateAnalyticsSettings', value: enable
    }, /*{
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    }*/).then((response) => {
      this.updatingStatus.loadEnd();
      return response.data.settings;
    }, (err) => {
      this.checkAxiosError(err);
      this.updatingStatus.loadError();
      throw err;
    })
  }

  loadSettings() {
    this.loadingStatus.loadStart();
    return httpAxiosApi.get('/webapi/webapi/securitysettings').then((response) => {
      this.loadingStatus.loadEnd();
      return response.data.settings;
    }, (err) => {
      this.checkAxiosError(err);
      this.loadingStatus.loadError();
      throw err;
    })
  }
}

const model = reactive(new AnalyticsModel())
const security = ref({analytics: false})

const loaded = computed(() => {
  return model.loadingStatus.isLoaded;
})

const loadSettings = () => {
  return model.loadSettings().then((settings) => {
    security.value = {...settings};
  });
}

onMounted(() => {
  loadSettings();
})

const onAnalyticsToggle = (value: any) => {
  model.activationSwitch(value).then((settings) => {
    security.value = {...settings};
  });
}

return { __sfc: true,AnalyticsModel, model, security, loaded, loadSettings, onAnalyticsToggle, SetupToggler }
}

})